import { useState } from "react";

// メールアドレスバリデーション
export const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
export const emailErrorMessage = "有効なメールアドレスを入力してください";

// 部屋番号バリデーション
export const roomNumberRegex = /^[\s\S]*$/;

// 電話番号バリデーション
export const phoneNumberRegex = /^[0-9]{10,11}$/;
export const phoneNumberErrorMessage =
  "半角、ハイフン無しで有効な電話番号を入力してください";

// UUIDバリデーション
export const UUID_CHARACTER_LIMIT = 22; // 文字数制限を定義

//StaticIpのバリデーション
export const StaticIpRegex = /^(\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}\/\d{1,2})$/;
export const StaticIpErrorMessage = "CIDR形式のIPアドレスを入力してください";

// IPv4アドレスのバリデーション
export const IpV4Regex = /^(\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3})$/;
export const IpV4ErrorMessage = "有効なIPv4アドレスを入力してください";

// // 各フィールドが変更されたかどうかを追跡する状態
//  const [isTouched, setIsTouched] = useState({
//   contractorName: false,
//   phoneNumber: false,
//   email: false,
// });

// // バリデーションエラーの状態
// const [validationErrors, setValidationErrors] = useState({
//   contractorName: '',
//   phoneNumber: '',
//   email: '',
// });

// // 入力が変更されたときのハンドラ
// const handleBlur = (field: string) => {
//   setIsTouched({
//     ...isTouched,
//     [field]: true,
//   });
// };

// // バリデーションロジック
// useEffect(() => {
//   const errors = {
//     contractorName: isTouched.contractorName && contractorName.trim() === '' ? '契約者氏名は必須です' : '',
//     phoneNumber: isTouched.phoneNumber && !phoneNumber.match(/^[0-9]{10,11}$/) ? '有効な電話番号を入力してください' : '',
//     email: isTouched.email && (
//       (isNew && !emailRegex.test(email)) ||
//       (!isNew && fetchedData?.email && !emailRegex.test(fetchedData.email))
//     ) ? '有効なメールアドレスを入力してください' : '',
//   };
//   setValidationErrors(errors);
// }, [contractorName, phoneNumber, email, fetchedData?.email, isNew, isTouched]);

// if (!email && !fetchedData?.email) {
//   setValidationErrors(prevErrors => ({
//     ...prevErrors,
//     email: 'メールアドレスを入力してください',
//   }));
//   return; // エラーがあるため、保存操作を中断
// }

// // エラーがある場合、保存を阻止
// if (Object.values(validationErrors).some((error) => error !== '')) {
//   alert('入力エラーがあります。修正してください。');
//   return;
// }
